// extracted by css-extract-rspack-plugin
export default {"wrapper":"_6cfa14e2"};